import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

import { ProductContextAccessDirective } from 'ish-core/directives/product-context-access.directive';
import { FeatureToggleModule } from 'ish-core/feature-toggle.module';

@Component({
  selector: 'ish-product-brand',
  templateUrl: './product-brand.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ProductContextAccessDirective, FeatureToggleModule, TranslateModule, RouterModule],
})
export class ProductBrandComponent {}
